/**
 * Class name merging utility.
 *
 * Combines `clsx` (conditional class logic) with `tailwind-merge` (conflict
 * resolution for Tailwind utility classes) into a single ergonomic helper.
 *
 * Usage:
 *   cn("px-4 py-2", isActive && "bg-blue-500", "px-6")
 *   // → "py-2 bg-blue-500 px-6"  (px-4 overridden by px-6 via tailwind-merge)
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
